import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SafePipe } from '@thehubz/client/core';
import { AnyType } from '@thehubz/shared/model';
import { ConfirmDialogData } from './confirm-dialog.service';

@Component({
  selector: 'sp-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent {
  messageList: string[] = [];
  fileUrl!: AnyType;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
    private safePipe: SafePipe,
  ) {
    if (data.message && data.message.includes('\n\n')) {
      this.messageList = data.message.split('\n\n');
    }
    if (data && data.downloadReport) {
      const blob = new Blob([data.downloadReport], { type: 'application/octet-stream' });
      this.fileUrl = this.safePipe.transform(window.URL.createObjectURL(blob), 'url');
    }
  }
}
